import React from 'react';
import { DataGrid } from '@mui/x-data-grid';

const DynamicTable = ({ data }) => {
  if (!data || data.length === 0) {
    return <div>No data available</div>;
  }

  // Get all unique keys from the data
  const allKeys = Array.from(new Set(data.flatMap(row => row.map(pair => pair.key))));

  const stringColumns = ['Client Name', 'Location','Category']

  // Prepare columns for DataGrid
  // In order to add column sort, need to identify which columns are text and which are numerical values
  // Potential idea: pass in defaul sort type, and list of exceptions that have column name and data type
  const columns = allKeys.map(key => ({
    field: key,
    headerName: key,
    flex: 1,
    type: stringColumns.includes(key) ? 'string' : 'number'
  }));

  // Prepare rows for DataGrid
  const rows = data.map((row, index) => {
    const rowData = { id: index };
    allKeys.forEach(key => {
      const pair = Array.isArray(row) ? row.find(pair => pair.key === key) : null;
      rowData[key] = pair
        ? !isNaN(pair.value) // Check if the value is a number
          ? Number(pair.value).toFixed(2)
          : pair.value // If not a number, leave it as-is
        : '';
    });
    return rowData;
  });

  return (
    <div style={{ height: 400, width: '100%' }}>
      <DataGrid
        disableRowSelectionOnClick
        rows={rows}
        columns={columns}
        density="compact"
        pageSize={5}
        rowsPerPageOptions={[5, 10, 20]}
        showToolbar
      />
    </div>
  );
};

export default DynamicTable;
